export default function padding(padding) {
  return { padding };
}
